import { createIcon } from '@chakra-ui/react';

export const UploadIcon = createIcon({
  displayName: 'UploadIcon',
  viewBox: '0 0 16 16',
  path: [
    <path
      key="1"
      d="M16.0039 14.223C16.0039 14.6945 15.8166 15.1466 15.4832 15.48C15.1498 15.8134 14.6976 16.0007 14.2261 16.0007L1.78169 16.0007C1.31019 16.0007 0.858006 15.8134 0.524609 15.48C0.191211 15.1466 0.00390911 14.6945 0.00390911 14.223L0.00390911 1.77851C0.00390911 1.30702 0.191211 0.854832 0.524609 0.521435C0.858006 0.188037 1.31019 0.000735283 1.78169 0.000735283L14.2261 0.000735283C14.6976 0.000735283 15.1498 0.188037 15.4832 0.521435C15.8166 0.854832 16.0039 1.30702 16.0039 1.77851L16.0039 14.223ZM8.8928 13.3341L8.8928 5.77851L12.0039 8.88962L13.2661 7.6274L8.00391 2.36518L2.74169 7.6274L4.00391 8.88962L7.11502 5.77851L7.11502 13.3341H8.8928Z"
      fill="#FF5000"
    />
  ]
});
